"use client";

import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "lib/utils"; 

// Root
const Sheet = DialogPrimitive.Root;

// Trigger
const SheetTrigger = DialogPrimitive.Trigger;

// Close
const SheetClose = DialogPrimitive.Close;

// Portal
const SheetPortal = DialogPrimitive.Portal;

// Overlay
const SheetOverlay = React.forwardRef(
  ({ className, ...props }, ref) => (
    <DialogPrimitive.Overlay
      ref={ref}
      className={cn(
        "fixed inset-0 z-40 bg-black/40 backdrop-blur-sm",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )}
      {...props}
    />
  )
);
SheetOverlay.displayName = "SheetOverlay";

// Content
const SheetContent = React.forwardRef(
  ({ side = "right", className, children, ...props }, ref) => {
    const sideStyles = {
      right:
        "fixed top-0 right-0 h-full w-3/4 sm:w-[300px] border-l bg-white dark:bg-gray-900",
      left:
        "fixed top-0 left-0 h-full w-3/4 sm:w-[300px] border-r bg-white dark:bg-gray-900",
      top:
        "fixed top-0 left-0 w-full h-1/3 border-b bg-white dark:bg-gray-900",
      bottom:
        "fixed bottom-0 left-0 w-full h-1/3 border-t bg-white dark:bg-gray-900",
    };

    const sideAnimations = {
      right:
        "data-[state=open]:slide-in-from-right data-[state=closed]:slide-out-to-right",
      left:
        "data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left",
      top:
        "data-[state=open]:slide-in-from-top data-[state=closed]:slide-out-to-top",
      bottom:
        "data-[state=open]:slide-in-from-bottom data-[state=closed]:slide-out-to-bottom",
    };

    return (
      <SheetPortal>
        <SheetOverlay />
        <DialogPrimitive.Content
          ref={ref}
          className={cn(
            "z-50 p-6 shadow-xl transition ease-in-out",
            "data-[state=open]:animate-in data-[state=closed]:animate-out",
            sideStyles[side],
            sideAnimations[side],
            className
          )}
          {...props}
        >
          {children}

          <SheetClose className="absolute right-4 top-4 rounded-sm opacity-70 hover:opacity-100 transition">
            <X className="h-4 w-4" />
          </SheetClose>
        </DialogPrimitive.Content>
      </SheetPortal>
    );
  }
);
SheetContent.displayName = "SheetContent";

export {
  Sheet,
  SheetTrigger,
  SheetClose,
  SheetContent,
};